import { create } from 'zustand'

// Define the type for items in your array
interface State {
  stateName: string | null | undefined
  stateId: number
}

// Define the store's state shape and actions
interface StateList {
  stateList: State[]
  setStates: (newStates: State[]) => void
}

export const useStateListStore = create<StateList>((set) => ({
  stateList: [],
  setStates: (newStates) => set({ stateList: newStates }),
  addStates: (statesToAdd: State[]) =>
    set((state) => ({
      stateList: [...state.stateList, ...statesToAdd],
    })),
}))
